import type { HiringManagerLinkedInAccountApi } from './types';

/**
 * Whether the Integrations row must show the locked Finlay Source channel
 * instead of the connect action. A plan without outreach carries no outreach
 * account, so connecting or reconnecting could only fail; only an account that
 * is actually active keeps the real row, so a tenant that downgraded can still
 * disconnect it. The account query resolves to null when there is no account,
 * so `undefined` means the lookup has not answered yet and the row keeps its
 * own loading and error states.
 */
export const isLinkedInLockedByPlan = (
  isOutreachLocked: boolean,
  account: HiringManagerLinkedInAccountApi | undefined,
) => isOutreachLocked && account !== undefined && account?.status !== 'Active';
